import type { FusionHubDataSourceWithIntegration } from "src/features/integrations/overview/table/IntegrationsTableContent.tsx";
import { SyncStatus } from "src/features/integrations/status/SyncStatus.tsx";
import { useDataSourceStatus } from "src/features/integrations/status/useDataSourceStatus.ts";

type Props = {
	dataSource: FusionHubDataSourceWithIntegration;
};

export const DataSourceStatusGlyph = ({ dataSource }: Props) => (
	<SyncStatus
		status={useDataSourceStatus(dataSource)}
		iconPosition="trailing"
		className="shrink-0"
	>
		{(status) => (
			<>
				<span className="hidden @sm:inline @xl:hidden">{status.word}</span>
				<span className="hidden @xl:inline">{status.phrase}</span>
			</>
		)}
	</SyncStatus>
);
